import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface WikiDraftsSourceSettings extends MemorySearchSettings {
  type: 'wiki-drafts';
}
